export default "__VITE_ASSET__8405ff0e__"